const FIREBASE_ID_LENGTH = 20;

export const carSlug = (car) => {
  const base = `${car.marca} ${car.modelo} ${car.ano}`
    .toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s]/g, '')
    .trim()
    .replace(/\s+/g, '-');
  return `${base}-${car._id}`;
};

export const extractCarId = (slug) => {
  return slug.slice(-FIREBASE_ID_LENGTH);
};
